import React, {useEffect, useState} from 'react'
import {EventOrder} from '../types/eventData'

import styles from './styles.module.scss'
import {useShipmentTracking} from '../../../pages/OrderManager/hooks'
import ThrobbingSubmit from '../../Fields/ThrobbingSubmit'

interface OrderStatusProps {
  openErrorModal: () => void
  eventOrder: EventOrder
}

interface TrackingNumber {
  trackingNumber: string
  trackingUrl: string
  narvarUrl: string
  returnTracking: string
  returnUrl: string
}
interface Shipment {
  trackingNumber: TrackingNumber
  link: string
}

export const OrderStatus: React.FC<OrderStatusProps> = ({openErrorModal, eventOrder}) => {
  const {homeTryOn, rental, shipmentTrackingLinks} = eventOrder
  const uniqueTrackingNumbers = [
    ...new Set(
      shipmentTrackingLinks
        .map((shipment: Shipment) => shipment?.trackingNumber?.trackingNumber)
        .filter((trackingNumber) => trackingNumber !== undefined),
    ),
  ]
  const shipmentTrackingMutation = useShipmentTracking()
  const [selectedTrackingCode, setSelectedTrackingCode] = useState('')

  useEffect(() => {
    if (shipmentTrackingMutation.isError) {
      openErrorModal()
    }
  }, [openErrorModal, shipmentTrackingMutation.isError])

  const getOrderStatusText = () => {
    if (homeTryOn) {
      return (
        <>
          Your home try-on begins when your package arrives - typically within a week. You will
          receive an email with your tracking information and it will display here once the order
          has shipped. Test drive it for 3 days and then send it back using the pre-paid
          shipping&nbsp;label.
        </>
      )
    }
    if (rental) {
      return (
        <>
          We&apos;ll start preparing your order 25 days before your event, and you may edit your
          order up until we begin. Orders arrive at least 10 days before the event. You will receive
          an email with your tracking information and it will display here once the order
          has&nbsp;shipped.
        </>
      )
    }
    return (
      <>
        We&apos;re preparing your order. You will receive an email with your tracking information
        and it will display here once the order has shipped.
      </>
    )
  }

  const handleTrackingClick = (trackingUrl: string) => {
    shipmentTrackingMutation.mutate({trackingNumber: trackingUrl})
    setSelectedTrackingCode(trackingUrl)
  }

  if (uniqueTrackingNumbers.length === 0) {
    return (
      <div className={styles.container}>
        <span className={styles.title}>This order is all set</span>
        <p className={styles.message}>{getOrderStatusText()}</p>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <span className={styles.title}>Shipped</span>
      <span className={styles.subtitle}>
        Your items have left the warehouse and are en route to your delivery address.
      </span>

      {uniqueTrackingNumbers.map((trackingNumber: string) => {
        return (
          <div className={styles.shipment} key={trackingNumber}>
            <div className={styles.label}>Tracking ID</div>
            <ThrobbingSubmit
              className={styles.button}
              disabled={
                shipmentTrackingMutation.isLoading && selectedTrackingCode === trackingNumber
              }
              isThrobbing={false}
              value={
                shipmentTrackingMutation.isLoading && selectedTrackingCode === trackingNumber
                  ? 'Loading...'
                  : trackingNumber
              }
              onClick={() => handleTrackingClick(trackingNumber)}
            />
          </div>
        )
      })}
    </div>
  )
}
